




























import { Component, Vue, Prop } from "vue-property-decorator";
import Huanzhejibenxinxi from "./contents/huanzhejibenxinxi.vue";
import CustomContentTransfer from "./contents/custom-content-transfer.vue";
import SystemContentTransfer from "./contents/system-content-transfer.vue";
import LiangbiaoContentTransfer from "./contents/liangbiao-content-transfer.vue";
@Component({
  components: {
    Huanzhejibenxinxi,
    CustomContentTransfer,
    SystemContentTransfer,
    LiangbiaoContentTransfer
  }
})
export default class TemplateTransferCmp extends Vue {
  @Prop()
  private projectId: any;
  @Prop()
  private template: any;
  @Prop()
  private patient: any;
  @Prop()
  private detail: any;
  private patientChange() {
    this.$emit("update:patient", this.patient);
  }
  private detailChange() {
    this.$emit("update:detail", this.detail);
  }
  /**
   * @description 初始化
   */
  private mounted() {
    // console.log(this.template);
    if (this.detail.content_id && this.detail["类别"] === "自定义模板") {
      this.template["模板"] = this.detail.data;
    }
  }
  /**
   * @description 退出组件后销毁可编辑状态
   */
  private destroyed() {
    this.$store.commit("updateResearchListComposeDiabled", true);
  }
}
